<template>
  <b-card no-body v-bind:class="{ 'power-off' : !isActive&&!isLoading, 'disconnected' : op_mode === 'DISCONNECTED', 'error' : op_mode === 'ERROR' }">
    <b-card-body>
      <div>
        <b-img v-if="op_mode!=='DISCONNECTED'&&isActive" src="@/assets/images/iotv/devices/ic_dehumidifier_on.png" class="device_icon"/>
        <b-img v-if="op_mode!=='DISCONNECTED'&&!isActive" src="@/assets/images/iotv/devices/ic_dehumidifier_off.png" class="device_icon"/>
        <b-img v-if="op_mode==='DISCONNECTED'" src="@/assets/images/iotv/devices/ic_dehumidifier_disconnected.png" class="device_icon"/>
      </div>
      <div v-if="!['DISCONNECTED','ERROR'].includes(op_mode)">
        <div @click="turnOnOff" @keyup.enter="turnOnOff" class="power_btn focusable" tabindex="0"/>
      </div>
    </b-card-body>
    <b-card-footer>
      <div class="card_btn" @click="load_component" @keyup.enter="load_component" tabindex="0" :class="{'focusable': op_mode!=='DISCONNECTED'}">
        <h4 class="tit" :class="{'marquee': isOverflow}" ref="title">{{ name }}</h4>
        <p class="desc" :class="{'marquee': isDescOverflow}" ref="desc">
          <template v-if="!isLoading">
            <template v-if="errorCode!==1308">
              <span class="state_info" v-if="!['ERROR'].includes(op_mode)">{{ op_mode ? $t(`property.DEVICE_DEHUMIDIFIER.dehumidifierJobMode.currentJobMode.${op_mode}`) : '' }}</span>
              <span class="state_info error" v-if="['ERROR'].includes(op_mode)">{{ $t('label.error') }}</span>
            </template>
            <template v-if="errorCode===1308">
              <span class="state_info error">{{ $t('error.1308') }}</span>
            </template>
          </template>
          <template v-if="isLoading">
            <span class="state_info">Loading...</span>
          </template>
        </p>
      </div>
    </b-card-footer>
    <div class="spinner" v-if=isLoading>
      <b-img src="@/assets/images/iotv/Spinner_large.gif"/>
    </div>
  </b-card>
</template>
<script>
import dehumidifierMixin from "@/mixins/cards/dehumidifier";

export default {
  name: 'CardDehumidifier',
  mixins: [dehumidifierMixin]
}
</script>
